import ListBlock from './list/browser';

export default {
	list: ListBlock
};
